const ABSOLUTE_URL_PATTERN = /^(?:[a-z]+:)?\/\//i;

const isTenantHost = (hostname) => {
  const configuredBase = String(process.env.REACT_APP_TENANT_BASE_DOMAIN || "")
    .trim()
    .toLowerCase();

  return Boolean(configuredBase && hostname.endsWith(`.${configuredBase}`));
};

export const getApiOrigin = () => {
  const configuredApiUrl = String(process.env.REACT_APP_API_URL || "").trim().replace(/\/$/, "");

  if (typeof window === "undefined") {
    return configuredApiUrl;
  }

  const hostname = window.location.hostname.toLowerCase();
  if (isTenantHost(hostname)) {
    return window.location.origin;
  }

  return configuredApiUrl || window.location.origin;
};

export const resolveApiUrl = (path = "") => {
  if (ABSOLUTE_URL_PATTERN.test(path)) return path;

  const origin = getApiOrigin().replace(/\/$/, "");
  const normalizedPath = String(path || "").replace(/^\/+/, "");
  return normalizedPath ? `${origin}/${normalizedPath}` : origin;
};
